import { FASTAPI_CONFIG } from '@/config/fastapi'

import { useFileApiService } from './fileApiService'

export interface ImageItem {
  filename: string
  url: string
}

/**
 * 检测字符串是否为图片文件名
 */
export function isImageFilename(filename: string): boolean {
  const imageExtensions = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.bmp',
    '.webp',
    '.svg'
  ]
  const lowerFilename = filename.toLowerCase()
  return imageExtensions.some((ext) => lowerFilename.endsWith(ext))
}

/**
 * 从ComfyUI的object_info中提取图片信息
 */
export function extractImagesFromObjectInfo(data: any): ImageItem[] {
  const images: ImageItem[] = []
  const seenFilenames = new Set<string>()

  // 遍历object_info中的节点信息，查找图片相关的节点
  for (const [, nodeInfo] of Object.entries(data)) {
    if (nodeInfo && typeof nodeInfo === 'object' && 'input' in nodeInfo) {
      const inputs = (nodeInfo as any).input
      if (inputs && typeof inputs === 'object') {
        for (const [, inputInfo] of Object.entries(inputs)) {
          if (
            inputInfo &&
            typeof inputInfo === 'object' &&
            'choices' in inputInfo
          ) {
            const choices = (inputInfo as any).choices
            if (Array.isArray(choices)) {
              choices.forEach((choice) => {
                if (
                  typeof choice === 'string' &&
                  isImageFilename(choice) &&
                  !seenFilenames.has(choice)
                ) {
                  seenFilenames.add(choice)
                  images.push({
                    filename: choice,
                    url: `/api/image/${choice}` // ComfyUI图片API路径
                  })
                }
              })
            }
          }
        }
      }
    }
  }

  return images
}

/**
 * 获取可用的图片列表
 */
export async function getAvailableImages(): Promise<ImageItem[]> {
  try {
    // 使用文件API服务获取图片列表，使用正确的分页和筛选参数
    const fileApi = useFileApiService()
    const response = await fileApi.get('/images', {
      page: 1,
      page_size: 50, // 获取前50张图片
      sort_by: 'created_at',
      sort_order: 'desc',
      recent_only: false // 获取所有图片，不只是最近使用的
    })

    console.log('getAvailableImages 响应:', response)

    if (response.files && Array.isArray(response.files)) {
      console.log('找到图片数量:', response.files.length)
      return response.files.map((file: any) => ({
        filename: file.filename,
        url:
          file.obs_url ||
          `${FASTAPI_CONFIG.BASE_URL}/api/v1/comfyui/view?filename=${file.filename}`
      }))
    } else {
      console.warn('响应格式不正确:', response)
    }
  } catch (error) {
    console.error('获取图片列表错误:', error)
  }

  // 如果API失败，返回空数组
  return []
}

/**
 * 检测ComboWidget的值是否包含图片文件
 */
export function hasImageFiles(values: string[]): boolean {
  return values.some((value) => isImageFilename(value))
}

/**
 * 过滤出图片文件
 */
export function filterImageFiles(values: string[]): string[] {
  return values.filter((value) => isImageFilename(value))
}
